// extracted by mini-css-extract-plugin
module.exports = {"Container":"FollowSchool_Container__MUDsJ","Button":"FollowSchool_Button__d7PCW","Unfollow":"FollowSchool_Unfollow__ucXWt"};